<template>
  <div id="app">
    <div class="app_header">
      <div class="header_left">
        <img src="./assets/header.png" alt="" />
      </div>
      <div class="header_right">
        <div :class="[$route.name == 'home' ? 'list activity' : 'list']">
          <span @click="gotoPage('')">首页</span>
        </div>
        <div :class="[$route.name == 'about' ? 'list activity' : 'list']">
          <span @click="gotoPage('about')">关于我们</span>
        </div>
        <div :class="[$route.name == 'astarPlan' ? 'list activity' : 'list']">
          <span @click="gotoPage('astarPlan')">星元计划</span>
        </div>
        <div :class="[$route.name == 'newsCenter' ? 'list activity' : 'list']">
          <span @click="gotoPage('newsCenter')">新闻中心</span>
        </div>
        <div :class="[$route.name == 'joinUs' ? 'list activity' : 'list']">
          <span @click="gotoPage('joinUs')">加入我们</span>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <div class="app_footer">
      <div class="widthCon">
        <div class="topCon">
        <div class="one">
          <img src="./assets/footerLogo.png" alt="" />
          <p>星元单</p>
        </div>
        <div class="two">
          <div class="title">公司</div>
          <div class="content">
            <div class="list" @click="gotoPage('about')">关于我们</div>
            <div class="list" @click="gotoPage('joinUs')">加入我们</div>
            <div class="list" @click="gotoPage('newsCenter')">新闻中心</div>
            <div
              class="list"
              @click="gotoPage('officialapi/agreement/detail?key=scqyyszcwq')"
            >
              隐私协议
            </div>
          </div>
        </div>
        <div class="three">
          <div class="title">联系我们</div>
          <div class="content">
            <div class="line">媒体问询：media@shop-astar.com</div>
            <div class="line">商务合作：bd@shop-astar.com</div>
            <div class="line">关联网站：http://www.shop-astar.com</div>
          </div>
          <div class="qrCon">
            <div class="code">
              <img src="./assets/qrcode1.jpg" alt="" />
              <p>抖音</p>
            </div>
            <div class="code">
              <img src="./assets/qrcode2.png" alt="" />
              <p>微博</p>
            </div>
            <div class="code">
              <img src="./assets/qrcode3.jpg" alt="" />
              <p>公众号</p>
            </div>
            <div class="code">
              <img src="./assets/qrcode4.png" alt="" />
              <p>快手</p>
            </div>
          </div>
        </div>
        <div class="four">
          <div class="title">咨询热线</div>
          <div class="content">
            <div class="line">4008910008</div>
            <div class="line">周一至周五</div>
            <div class="line">9:00-12:00 14:00-17:00</div>
          </div>
        </div>
      </div>
      <div class="bottomCon">
        <p>公司名称:上海萃达科技有限公司</p>
        <p>沪公网安备31011002006688号|沪ICP备2024085092号-5</p>
        <p>统一社会信用代码:91310110MADQ0KK14L</p>
        <p>联网备案信息:沪ICP备2024085092号</p>
        <p>APP服务备案号:沪ICP备2024085092号-7A</p>
        <p>经营许可证编号:沪B2-20241048</p>
      </div>
      </div>
    </div>
    <div class="app_nav">
      <div class="nav1">
        <div
          class="navCon"
          @mouseover="nav1Flag = true"
          @mouseout="nav1Flag = false"
        >
          <img src="./assets/nav1.png" alt="" />
          <p>客服咨询</p>
        </div>
        <div class="hoverCon1" v-if="nav1Flag">
          <div class="line1">客服电话：4008910008</div>
          <div class="line2">周一至周五：09:00-17:00</div>
        </div>
      </div>
      <div class="nav2">
        <div
          class="navCon"
          @mouseover="nav2Flag = true"
          @mouseout="nav2Flag = false"
        >
          <img src="./assets/nav2.png" alt="" />
          <p>关注我们</p>
        </div>
        <div class="hoverCon2" v-if="nav2Flag">
          <img src="./assets/qrcode3.jpg" alt="" />
          <p>扫码关注“星元单”公众号</p>
        </div>
      </div>
      <div class="nav2">
        <div
          class="navCon"
          @mouseover="nav3Flag = true"
          @mouseout="nav3Flag = false"
        >
          <img src="./assets/nav3.png" alt="" />
          <p>下载APP</p>
        </div>
        <div class="hoverCon3" v-if="nav3Flag">
          <img src="./assets/qrcode5.png" alt="" />
          <p>扫码下载“星元单”APP</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      nav1Flag: false,
      nav2Flag: false,
      nav3Flag: false,
    };
  },
  methods: {
    gotoPage(page) {
      this.$router.push({ path: "/" + page });
    },
  },
};
</script>

<style lang="less">
html::-webkit-scrollbar-corner,
body::-webkit-scrollbar-corner {
  width: 0;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 16px;
  height: 16px;
  background: transparent;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-left: 1px solid rgba(244, 244, 244, 0.14);
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 4px solid transparent;
  background-clip: content-box;
  background-color: #d2d2d2;
}
* {
  margin: 0;
  padding: 0;
}
body {
  font-size: 0px;
}
.app_nav {
  position: fixed;
  right: 0;
  top: calc(50% - 120px);
  border-radius: 6px 0px 0px 6px;
  background: rgba(0, 0, 0, 0.3);
  padding: 6px 0 17.5px 0;
  width: 50px;
  height: 243px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  z-index: 999;
  text-align: center;
  > div {
    position: relative;
  }
  .navCon {
    cursor: pointer;
    img {
      width: 30px;
      height: 30px;
    }
    p {
      font-family: Source Han Sans;
      font-size: 10px;
      font-weight: normal;
      line-height: 16px;
      letter-spacing: normal;
      color: #ffffff;
      margin-top: 5px;
    }
  }
  .hoverCon1 {
    background: url("./assets/leftNav.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    width: 187px;
    height: 59px;
    top: 5px;
    right: 35px;
    text-align: left;
    .line1 {
      font-family: Source Han Sans;
      font-weight: 500;
      font-size: 12px;
      font-variation-settings: "opsz" auto;
      margin-top: 10px;
      margin-left: 20px;
      margin-bottom: 5px;
    }
    .line2 {
      font-family: Source Han Sans;
      font-weight: 400;
      font-size: 12px;
      margin-left: 20px;
      color: #666;
    }
  }
  .hoverCon2 {
    background: url("./assets/leftNav2.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    width: 182px;
    height: 172px;
    top: -10px;
    right: 35px;
    img {
      width: 122px;
      height: 122px;
      border-radius: 6px;
      margin-top: 14px;
      transform: translatex(-4px);
    }
    p {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 22px;
      letter-spacing: normal;
      color: #222222;
      transform: translatex(-3px);
    }
  }
  .hoverCon3 {
    background: url("./assets/leftNav2.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    width: 182px;
    height: 172px;
    top: -10px;
    right: 35px;
    img {
      width: 100px;
      height: 100px;
      border-radius: 6px;
      margin-top: 24px;
      transform: translatex(-4px);
    }
    p {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 22px;
      letter-spacing: normal;
      color: #222222;
      transform: translatex(-3px);
      margin-top: 15px;
    }
  }
}
.app_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 74px;
  font-family: Source Han Sans;
  font-size: 20px;
  font-weight: 350;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  color: #222222;
  .header_left {
    img {
      height: 40px;
      margin-left: 32px;
    }
  }
  .header_right {
    margin-right: 55px;
    .list {
      display: inline-block;
      width: 112px;
      height: 40px;
      line-height: 40px;
      margin-right: 13px;
      text-align: center;
      span {
        cursor: pointer;
      }
    }
    .activity {
      border-radius: 4px;
      background: #4a90e2;
      color: #fff;
    }
  }
}
.app_footer {
  padding: 73px 0 37px 0;
  background: #111827;
  .widthCon{
    width: 1200px;
    margin: 0 auto;
  }
  .topCon {
    display: flex;
    justify-content: space-between;
    .one {
      width: 140px;
      text-align: center;
      img {
        width: 140px;
        height: 140px;
      }
      p {
        font-family: Source Han Sans;
        font-size: 28px;
        font-weight: bold;
        line-height: 44px;
        letter-spacing: normal;
        color: #ffffff;
        margin-top: 17px;
      }
    }
    .two {
      .title {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        letter-spacing: normal;
        color: #ffffff;
        margin-bottom: 16px;
      }
      .content {
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: normal;
        color: #9ca3af;
        .list {
          margin-top: 20px;
          cursor: pointer;
        }
        .list:hover {
          color: #409eff;
        }
      }
    }
    .three {
      .title {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        letter-spacing: normal;
        color: #ffffff;
      }
      .content {
        margin: 22px 0;
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: normal;
        color: #9ca3af;
        .line {
          margin-bottom: 10px;
        }
      }
      .qrCon {
        .code {
          width: 80px;
          text-align: center;
          display: inline-block;
          margin-right: 15px;
          img {
            width: 80px;
            height: 80px;
            border-radius: 4px;
          }
          p {
            font-family: Source Han Sans;
            font-size: 14px;
            font-weight: normal;
            line-height: 16px;
            letter-spacing: normal;
            color: #9e9e9e;
            margin-top: 14px;
          }
        }
      }
    }
    .four {
      .title {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        letter-spacing: normal;
        color: #ffffff;
        margin-bottom: 22px;
      }
      .content {
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: normal;
        color: #9ca3af;
        .line {
          margin-bottom: 10px;
        }
      }
    }
  }
  .bottomCon {
    margin-top: 58px;
    font-family: Source Han Sans;
    font-size: 14px;
    font-weight: normal;
    line-height: 26px;
    text-align: center;
    letter-spacing: normal;
    color: #9e9e9e;
    text-align: center;
  }
}
</style>
